"use client";

import { Alert, Text } from "@zapier/design-system";
import { Notification as NotificationType } from "../types";
import useTimer from "./useTimer";
import styles from "./Notification.module.css";
interface Props {
  index: number;
  notification: NotificationType;
  onDismiss: (id: string) => void;
  timeout: number;
}

/**
 * A popup toast-style notification
 */
export function Notification({
  notification,
  onDismiss,
  timeout
}: Props) {
  const {
    title,
    message,
    type
  } = notification;
  function handleDismiss() {
    if (notification.onDismiss) {
      notification.onDismiss(notification);
    }
    onDismiss(notification.id);
  }
  const {
    onPause,
    onResume
  } = useTimer(handleDismiss, timeout);
  return <div className={styles.root} onMouseEnter={onPause} onMouseLeave={onResume} data-sentry-component="Notification" data-sentry-source-file="Notification.tsx">
      <Alert onDismiss={handleDismiss} type={type} layout="toast" data-sentry-element="Alert" data-sentry-source-file="Notification.tsx">
        {title && <strong>{title}</strong>}
        {title && message && <br />}
        {title && message ? <Text type="smallPrint1" color="neutral700">
            {message}
          </Text> : <span>{message}</span>}
      </Alert>
    </div>;
}